import React, { useEffect } from "react";
import flower from "./ahfod.svg";

function About() {

  useEffect(() => {
    document.title = "About";
  }, []);
  
  return (
    <div className="container">
      <h1>About</h1>
      {/* Add your about page content here */}
      <p>The world is a beautiful place 🌍</p>
      <p>
        A beautiful place with beautiful creatures 🦜🦚
      </p>
      <p>In an attempt to connect with the beings that we share this planet with, I created <i>Nature Cam</i> to check on how they are doing.
      </p>
      <p>
      On this page, you will find sloths 🦥 polar bears 🐻‍❄️ giraffes 🦒 penguins 🐧 otters 🦦 toucans, and more !
      </p>
      <p>
      The modern internet has made it possible to stay connected with the lives of all these wonderful creatures and people around the world.
      </p>
      <p>
        <strong>
        So, shall we take a look at what they are up to <a href="https://www.worldcam.vercel.app/" style={{ textDecoration: "underline" }}>today</a>?
        </strong>
        
      </p>
      <p>
        <i>(P.S. Refresh the Home page to find new animals)</i>
      </p>
      <div class="signature">
        <h1 style={{ margin: 0 }}>~</h1>
        <img
          src={flower}
          alt="A Head Full of Dreams"
          style={{ height: "50px" }}
        />
        <h1 style={{ margin: 0 }}>~</h1>
      </div>
      <p className="coffee">
        <i>
          If you would liked this project, please consider supporting{" "}
          <a
            href="https://buymeacoffee.com/aaryamanpatel"
            style={{ textDecoration: "underline" }}
            rel="noopener"
            target="_blank"
          >
            here
          </a>{" "}
        </i>
        ! ☕️
      </p>
      {/* <p>
            What started as a website for finding old Coldplay interviews has turned into a ‘Wayback Machine’ for finding some of the wildest, weirdest, and most fascinating videos of the old internet.
        </p> */}
      <br></br>
      <p className="disc">
        <i>
          Disclaimer: <b>Nature Cam</b> is not affiliated with YouTube and does not
          claim ownership of any content displayed. All video thumbnails are
          property of their respective owners.
        </i>
      </p>
    </div>
  );
}

export default About;
